/**
 * Get mixpanel token
 */
export function getMixPanelToken() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? '0c3b5ee26b9d2e52e50d3d3ba2140978'
    : '0c3b5ee26b9d2e52e50d3d3ba2140978';
}

/**
 * Get posthog key
 */
export function getPostHogKey() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'phc_aDno2rR0bKKRakNBVTMEtlzwBH7vfgl4mC0Dr8DAnZC'
    : 'phc_dqhatovy3EwLg2qK00LKcoTKS1RTUMYYBRJK6dgS60y';
}

/**
 * Get posthog host
 */
export function getPostHogHost() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'https://ap.svc.urbanpiper.com/posthog'
    : 'https://us.i.posthog.com';
}

/**
 * Get recaptcha site key
 */
export function getRecaptchaSiteKey() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? '6LejhEEnAAAAAOlGPXLj3JEl0sPJsLq4fBn3EMeI'
    : '6LejhEEnAAAAAOlGPXLj3JEl0sPJsLq4fBn3EMeI';
}

/**
 * Get base URL for Prime
 */
export function getBaseUrlPrime() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'https://prime.urbanpiper.com'
    : 'https://stl-prime.staging.svc-hz.urbanpiper.com';
}

/**
 * Get base URL for Atlas
 */
export function getBaseUrlAtlas() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'https://atlas.urbanpiper.com'
    : 'https://test-atlas.urbanpiper.com';
}

/**
 * Non-production Atlas environments a user can be redirected to. The `host`
 * keys map to auth-service's ALLOWED_REDIRECT_HOSTS.
 */
export const ATLAS_STAGING_ENVS = [
  {
    host: 'atl-posint',
    name: 'POS Integration',
    url: 'https://atlas-pos-int.urbanpiper.com',
    desc: 'For POS partners and anyone building or testing a POS integration with UrbanPiper.',
  },
  {
    host: 'atl-stage',
    name: 'Staging',
    url: 'https://test-atlas.urbanpiper.com',
    desc: "UrbanPiper's internal environment for testing upcoming releases.",
  },
];

/**
 * Entry hosts (?host=...) are only honored for the MCP OAuth flow: mcp-*
 * hosts ride on atlas logins so the post-login redirect reaches the MCP
 * server callback. The Atlas staging/POS-int choice is made explicitly in
 * the env picker (which sends its own atl-* host at redirect time), and
 * prime always uses its default URL — no other entry host is ever applied.
 */
const APP_HOST_PREFIXES = {
  atlas: ['mcp-'],
};

/**
 * Return the redirect host if it belongs to the target app, else null.
 */
export function redirectHostForApp(appName, redirectHost) {
  const prefixes = APP_HOST_PREFIXES[appName] || [];
  return redirectHost && prefixes.some(p => redirectHost.startsWith(p))
    ? redirectHost
    : null;
}

/**
 * Whether to ask the user which Atlas environment (POS Integration vs
 * Staging) to continue to before redirecting. Never on production builds.
 * On test builds, only when the redirect would land on one of the
 * ATLAS_STAGING_ENVS hosts (no host captured, or one of those two) — an
 * explicit host like mcp-* or atl-local is respected as-is. Also skipped
 * inside the mobile app webview, where the token is handed to the app
 * instead of a browser redirect.
 */
export function shouldSelectAtlasEnv(appName, redirectHost) {
  if (import.meta.env.ULE_BUILD_ENV === 'production') {
    return false;
  }

  if (appName !== 'atlas' || window.ReactNativeWebView) {
    return false;
  }

  return !redirectHost || ATLAS_STAGING_ENVS.some(env => env.host === redirectHost);
}

/**
 * Get base URL for the Atlance API (partner referral signup)
 */
export function getBaseUrlAtlance() {
  if (import.meta.env.DEV) {
    // proxied by the vite dev server (see vite.config.js) to avoid CORS
    return '/atlance';
  }

  // Staging builds (login-staging) talk to the staging Atlance API, so a
  // staging referral link is served by the staging rail end to end.
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'https://api.atlance.urbanpiper.ai'
    : 'https://atlance-staging.up.railway.app';
}

/**
 * Get base URL for Temp Access
 */
export function getBaseUrlTempAccess() {
  return import.meta.env.ULE_BUILD_ENV === 'production'
    ? 'https://biz.urbanpiper.com/portal/tempuser/'
    : 'https://staging.urbanpiper.com/portal/tempuser/';
}
